export const FETCH_LIST_MOVIES_REQUEST = 'FETCH_LIST_MOVIES_REQUEST'
export const FETCH_LIST_MOVIES_SUCCESS = 'FETCH_LIST_MOVIES_SUCCESS'
export const FETCH_LIST_MOVIES_FAILURE = 'FETCH_LIST_MOVIES_FAILURE'